var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.019 9.08059C11.409 9.08059 11.7704 8.90435 12.1889 8.49623L20.4633 0.510149C20.1114 0.176236 19.4552 0.0185547 18.5136 0.0185547H3.20109C2.40217 0.0185547 1.84103 0.16696 1.52718 0.473048L9.84918 8.49623C10.2581 8.89507 10.6195 9.08059 11.019 9.08059ZM0.737772 14.5066L7.46196 8.0232L0.71875 1.53971C0.576087 1.79942 0.5 2.24464 0.5 2.88464V13.1247C0.5 13.7832 0.576087 14.247 0.737772 14.5066ZM3.48642 16H18.799C19.5979 16 20.1495 15.8516 20.4633 15.5548L13.6059 8.93218L12.9783 9.55364C12.322 10.1658 11.7038 10.4441 11.019 10.4441C10.3247 10.4441 9.70652 10.1658 9.05978 9.55364L8.42256 8.93218L1.58424 15.5455C1.94566 15.8516 2.57337 16 3.48642 16ZM21.2717 14.4974C21.4239 14.2284 21.5 13.774 21.5 13.1247V2.88464C21.5 2.26319 21.4239 1.81797 21.2908 1.56754L14.5666 8.0232L21.2717 14.4974Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailStart);
export default __webpack_public_path__ + "static/media/mail_start.5094b992e28c5951b49410df9ba71958.svg";
export { ForwardRef as ReactComponent };